<template>
  <div style="position: relative;font-weight: 500;">
    <div
      style="position: absolute; top: 75px; right: 13px;font-size: 14px; line-height: 15px;font-weight: 700; width: 110px;"
      class="text-center"
    >
      <span></span>
      {{ $i18n.t('contact_us_pic_line1') }}
      <br>
      {{ $i18n.t('contact_us_pic_line2') }}
      <br>
      {{ $i18n.t('contact_us_pic_line3') }}

    </div>
    <div
      style="position: absolute; top: 203px; left: 20px;font-size: 14px; font-weight: 700;"
      class="contact-man-body"
    >
      <span style="font-size: 19px; letter-spacing: -0.6px">
        {{ $i18n.t('contact_us').toUpperCase() }}
      </span><br>
      <span style="margin-top: 10px;font-weight: 500;font-size: 12px;">Costasolrent.com</span><br>
      <br>
      <template v-if="$i18n.t('contact_us_phone_number1') && $i18n.t('contact_us_phone_number1') !== 'contact_us_phone_number1'">
        <img :src="'/img/contact-phone.png'" />
        {{ $i18n.t('contact_us_phone_number1') }}
        <br>
      </template>
      <template v-if="$i18n.t('contact_us_phone_number2') && $i18n.t('contact_us_phone_number2') !== 'contact_us_phone_number2'">
        <img :src="'/img/contact-phone.png'" />
        {{ $i18n.t('contact_us_phone_number2') }}
        <br>
      </template>
      <img :src="'/img/contact-email.png'" /> info@costasolrent.com<br>
      <br>
      <img :src="'/img/contact-facebook.png'" /> Costasolrent.com<br>
      <img :src="'/img/contact-instagram.png'" /> Costasolrent.com<br>
      <div
        v-if="$i18n.t('contact_us_bottom_line') && $i18n.t('contact_us_bottom_line') !== 'contact_us_bottom_line'"
        style="font-weight: 700; font-size: 16px; margin-top: 10px;letter-spacing: -0.4px; padding-right: 30px;"

      >
        <br>
        {{ $i18n.t('contact_us_bottom_line') }}
      </div>

    </div>
    <img
      v-if="lang"
      style="border-radius: 6px; overflow: hidden"
      :src="$i18n.t('contact_us_bottom_line') && $i18n.t('contact_us_bottom_line') !== 'contact_us_bottom_line'
      ? '/img/contact_bg2.jpeg'
      : '/img/contact_bg.jpeg'"
    />
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ContactBannerNew',

  computed: {
    ...mapFields(Object.keys(state)),
  },
}
</script>

<style lang="scss">
.contact-man-body {
  font-size: 13px;
  line-height: 14px;
  img {
    position: relative;
    top: 5px;
    margin-right: 12px;
  }
}
</style>
